/** Robota.ua resume-search rubrics (``dictionary/rubric``, fetched
 * 2026-06-05 from https://ua-api.robota.ua/dictionary/rubric). The
 * dictionary is small and stable, so we embed it instead of proxying
 * the vendor call through the backend; ids are sent as
 * ``ColdSearchFilters.specialization``. */
export const ROBOTA_RUBRICS: ReadonlyArray<{ id: string; name: string }> = [
  { id: '33', name: 'Автобізнес — Сервісне обслуговування' },
  { id: '11', name: "Адміністративний персонал — Водії — Кур'єри" },
  { id: '18', name: 'Банки — Інвестиції — Лізинг' },
  { id: '27', name: 'Будівництво — Архітектура' },
  { id: '6', name: 'Бухгалтерія — Податки — Фінанси підприємства' },
  { id: '32', name: 'Виробництво — Інженери — Технологи' },
  { id: '8', name: 'Готелі — Ресторани — Кафе' },
  { id: '34', name: 'Державні установи — Місцеве самоврядування' },
  { id: '15', name: 'Дизайн — Графіка — Фото' },
  { id: '3', name: 'HR спеціалісти — Бізнес-тренери' },
  { id: '1', name: 'IT' },
  { id: '31', name: 'Закупівлі — Постачання' },
  { id: '14', name: 'Консалтинг — Аналітика — Аудит' },
  { id: '21', name: 'Культура — Шоу-бізнес — Розваги' },
  { id: '5', name: 'Логістика — Митниця — Склад' },
  { id: '24', name: 'Маркетинг — Реклама — PR' },
  { id: '22', name: 'Медіа — Видавнича справа' },
  { id: '9', name: "Медицина — Фармацевтика — Охорона здоров'я" },
  { id: '25', name: 'Морські спеціальності' },
  { id: '10', name: 'Наука — Освіта — Переклад' },
  { id: '13', name: 'Некомерційні — Громадські організації' },
  { id: '28', name: 'Нерухомість' },
  { id: '4', name: 'Охорона — Безпека — Силові структури' },
  { id: '17', name: 'Продажі — Клієнт-менеджмент' },
  { id: '20', name: 'Робочі спеціальності — Персонал для дому' },
  { id: '26', name: 'Сільське господарство — Агробізнес — Лісове господарство' },
  { id: '7', name: 'Спорт — Краса — Оздоровлення' },
  { id: '19', name: 'Страхування' },
  { id: '30', name: "Студенти — Початок кар'єри — Без досвіду" },
  { id: '2', name: "Телекомунікації — Зв'язок" },
  { id: '12', name: 'Топ-менеджмент — Директори' },
  { id: '16', name: 'Торгівля' },
  { id: '23', name: 'Туризм — Подорожі' },
  { id: '29', name: 'Юристи, адвокати, нотаріуси' },
];
